import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-empty-shopping-cart',
  imports: [NgClass],
  templateUrl: './empty-shopping-cart.component.html',
  styleUrl: './empty-shopping-cart.component.css',
})
export class EmptyShoppingCartComponent {
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#EE5C39';
}
